import { render, staticRenderFns } from "./claim-register.vue?vue&type=template&id=39193503&scoped=true&"
import script from "./claim-register.vue?vue&type=script&lang=js&"
export * from "./claim-register.vue?vue&type=script&lang=js&"
import style0 from "./claim-register.vue?vue&type=style&index=0&id=39193503&lang=scss&scoped=true&"
import style1 from "./claim-register.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39193503",
  null
  
)

export default component.exports